const title = (title) => {
  return `
    <summary>
      <h4 class="subtitle-2 mb-0">
        ${title}
      </h4>
      <!-- <i aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light"></i> -->
    </summary>
  `
}

export default title
